import { FieldType } from '_clean-code/pages/BasicProductionPage/components/CustomFieldModal/context';
import { CustomFieldType } from '_clean-code/pages/BasicProductionPage/context';

export type EntityType = 'work_orders' | 'production_advancements';
export interface CreateCustomFieldParams {
  name: string;
  type: FieldType;
  entity: CustomFieldType;
  config: any;
  default: any;
}

export interface UpdateCustomFieldParams {
  id: string;
  name: string;
  config?: any;
  default?: any;
}

export type CustomFieldsResponseType = {
  [K in EntityType]: EntityCustomFields;
};

export interface EntityCustomFields {
  [key: string]: CustomFieldEntityInterface[];
}

export interface CustomFieldEntityInterface {
  id: string;
  companyId: number;
  name: string;
  type: string;
  config: Config | ConfigForSingleSelect;
  default:
    | DefaultForMultiSelect
    | DefaultForSingleSelect
    | DefaultForNumberField
    | DefaultForOtherField;
}

export interface Config {
  values: string[];
}

export interface ConfigForSingleSelect {
  values: string[];
  allowEmpty: boolean;
}

export interface DefaultForSingleSelect {
  value: string;
}
export interface DefaultForMultiSelect {
  values: string[];
}

export interface DefaultForNumberField {
  value: number;
}

export interface DefaultForOtherField {}

export interface FileMetaData {
  url: string;
  filename: string;
  extension: string;
  fileSize: number;
  mimeType: string;
}
export interface GetCustomFieldsParams {
  entity: CustomFieldEntity;
}

export enum CustomFieldEntity {
  PRODUCTION_ADVANCEMENTS = 'production_advancements',
  PRODUCTION_BATCHES = 'production_batches',
  WORK_ORDERS = 'work_orders'
}

export enum CustomFieldTypeEnum {
  TEXT = 'text',
  TEXT_AREA = 'text_area',
  NUMBER = 'number',
  CHECKBOX = 'checkbox',
  SINGLE_SELECT = 'single_select',
  MULTI_SELECT = 'multi_select',
  FILE = 'file',
  IMAGE = 'image',
  DATE = 'date'
}

export interface CustomField {
  id: string;
  name: string;
  type: CustomFieldTypeEnum;
  config: any;
  default: any;
}

export interface ICustomFieldsService {
  createCustomField(params: CreateCustomFieldParams): Promise<void>;
  updateCustomField(params: UpdateCustomFieldParams): Promise<void>;
  deleteCustomField(params: string): Promise<void>;
  fetchCustomFields(params: EntityType): Promise<CustomFieldsResponseType>;
  downloadFile(params: string): Promise<FileMetaData>;
  getCustomFields(
    entity: CustomFieldEntity
  ): Promise<{ entity: CustomFieldEntity; value: CustomField[] }>;
  uploadFile(file: File): Promise<string>;
}
